import React,  { Component } from 'react';
//import axios from '../../../axios-url';

import {Button} from 'primereact/button';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import { Link } from "react-router-dom";
import UploadImage from '../../../assets/images/uploadImg.svg';
class FileUpload extends Component{
    state = {
        file:null,
        filesArray:[],
        loading : false
    };
 

    // handleImageChange = (e,folderName) => {
    //     e.preventDefault();
    //     this.setState({loading:true});
    //     let file = e.target.files[0];
    //     let readerShow = new FileReader();
    //     readerShow.readAsDataURL(file);
    //     readerShow.onloadend = () => {    
    //       this.setState({ file: readerShow.result});
    //     };
    //     const frmData = new FormData();
    //     frmData.append('file', file,  file.name );
    //     return axios.post('/master/api/upload?FolderName='+folderName, frmData ).then(response =>{ 
    //         let filesArray = [...this.state.filesArray];
    //         filesArray.push(response.data);
    //         this.setState({filesArray:filesArray,loading:false});

            
    //     })
    //     .catch(err => {
    //         this.growl.show({severity: 'error', summary: null, detail: 'File Upload Failed'});
    //         this.setState({loading:false});
    //     })  
    // }
    


    actionTemplate = (rowData, deleteImage) => { 
        let rowIndex = rowData.filePath;
        return <div className="actionCenter">
           <Link to={rowData.filePath}><Button type="button" icon="pi pi-download" className="p-button-secondary ml1"></Button></Link>
           <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => deleteImage(rowIndex)}></Button>
           </div>;
    }

    
    render(){     
       
        let count = 100;
        if(this.props.count){
             count= this.props.count;
        }
        return (
            <> 
                { 
                (this.props.filesArray.length < count) &&
                <div>
                    <input type="file" name="file" id="file-7" className="inputfile inputfile-6" onChange={this.props.handleImageChange} />
                    <label for="file-7"><span></span> <strong><img src={UploadImage} alt="upload im"/> Choose a file&hellip;</strong></label>
                </div>
                }

                {   
                    (this.props.filesArray && this.props.filesArray.length > 0) &&
                    <DataTable className="animated fadeIn" rowHover responsive value={this.props.filesArray}>
                        <Column field="filePath" header="File Path" style={{display:'none'}}/>
                        <Column field="fileName" header="File Name" />
                        <Column field="fileExtention" header="File Extention"/>
                        <Column body={(rowData)=>this.actionTemplate(rowData,this.props.deleteImage)}/>
                    </DataTable> 
                }
                

            </>
        )
    }
}

export default FileUpload;